module.exports = __webpack_public_path__ + "media/music/saw_lead_9-4c0a52d1.mp3";